<app-side-menu>
  <div class="ser-page" *ngIf="!isLoading">
    <div class="ser-wrap">
      <!-- Cabeçalho -->
      <div class="ser-top">
        <button type="button" class="ser-back" (click)="onBack()" aria-label="Voltar">
          <i class="fas fa-chevron-left"></i>
        </button>
        <div>
          <h1 class="ser-title">Registrar recebimento</h1>
          <p class="ser-sub">Preencha as informações de conferência e nota fiscal.</p>
        </div>
      </div>

      <div class="ser-success" *ngIf="showSuccess">
        <div class="ser-success__icon">
          <i class="fas fa-check"></i>
        </div>
        <div class="ser-success__text">
          <h3>Recebimento concluído com sucesso</h3>
          <p>O estoque foi atualizado conforme a conferência.</p>
        </div>
        <button type="button" class="ser-success__close" (click)="showSuccess = false" aria-label="Fechar">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="ser-grid" *ngIf="movement">
        <!-- Coluna esquerda: contexto -->
        <div class="ser-col ser-col--aside">
          <div class="ser-card ser-card--sticky">
            <div class="ser-icohead">
              <i class="fas fa-cube"></i>
            </div>
            <div class="ser-aside__block">
              <span class="ser-kicker">Item</span>
              <h2 class="ser-itemname">{{ getItemDisplayName(movement) }}</h2>
              <p class="ser-itemcode" *ngIf="getItemDisplayCode(movement) as code">
                <span class="ser-muted">Código</span> <strong>{{ code }}</strong>
              </p>
              <p class="ser-ctxline ser-ctxline--muted" *ngIf="movement.itemId">
                Cadastro de estoque (id): <strong>{{ movement.itemId }}</strong>
              </p>
              <p class="ser-ctxline">{{ getItemReceiptAuxLine(movement) }}</p>
            </div>

            <div class="ser-aside__block ser-aside__block--po" *ngIf="purchaseOrderContext as po">
              <span class="ser-kicker">Pedido de compra</span>
              <h3 class="ser-ponum">{{ po.orderLabel }}</h3>
              <p class="ser-ctxline" *ngIf="po.supplierName">
                <span class="ser-muted">Fornecedor</span>
                <span class="ser-strong ser-strong--block">{{ po.supplierName }}</span>
              </p>
              <p class="ser-ctxline" *ngIf="po.status">
                <span class="ser-muted">Situação</span>
                <span class="ser-strong ser-strong--block">{{ po.status }}</span>
              </p>
              <p class="ser-ctxline" *ngIf="po.expectedDelivery">
                <span class="ser-muted">Entrega prevista</span>
                <span class="ser-strong ser-strong--block">{{ po.expectedDelivery }}</span>
              </p>
              <p class="ser-ctxline ser-ctxline--wrap" *ngIf="po.description">{{ po.description }}</p>
              <p class="ser-ctxline ser-ctxline--wrap ser-ctxline--muted" *ngIf="po.notes">
                <strong>Obs. pedido:</strong> {{ po.notes }}
              </p>
              <p class="ser-ctxline ser-ctxline--wrap ser-items-sum" *ngIf="po.itemsSummary">
                <strong>Itens do pedido:</strong> {{ po.itemsSummary }}
              </p>
              <button type="button" class="ser-linkpo" (click)="goToPurchaseOrder(po.id)">
                <i class="fas fa-external-link-alt me-1"></i>
                Abrir pedido
              </button>
            </div>

            <div class="ser-panels">
              <div class="ser-rowline">
                <span class="ser-muted">Origem</span>
                <span class="ser-strong">{{ formatOrigin(movement) }}</span>
              </div>
              <div class="ser-rowline">
                <span class="ser-muted">Qtd. na movimentação</span>
                <span class="ser-qty">{{ movement.quantity | number:'1.0-4' }} und.</span>
              </div>
              <div class="ser-rowline">
                <span class="ser-muted">Máx. a receber</span>
                <span class="ser-qty">{{ maxReceivableQuantity | number:'1.0-4' }} und.</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Formulário -->
        <div class="ser-col ser-col--main">
          <form [formGroup]="receiptForm" (ngSubmit)="onSubmit()" class="ser-formcard">
            <div class="ser-section">
              <h3 class="ser-h3">
                <i class="fas fa-clipboard-check ser-h3--indigo"></i>
                Dados da conferência
              </h3>
              <div class="ser-fields">
                <div class="ser-field">
                  <label class="ser-label">
                    Quantidade recebida <span class="ser-req">*</span>
                    <span class="ser-muted ser-label__hint">(máx. {{ maxReceivableQuantity | number:'1.0-4' }})</span>
                  </label>
                  <input
                    type="number"
                    class="ser-input"
                    formControlName="receivedQuantity"
                    [class.ser-input--err]="isFieldInvalid('receivedQuantity')"
                    [attr.max]="maxReceivableQuantity"
                    min="0.0001"
                    step="any"
                    placeholder="Ex.: 10"
                    (input)="onReceivedQuantityInput()"
                  />
                  <span class="ser-err" *ngIf="isFieldInvalid('receivedQuantity')">
                    {{ getReceivedQtyErrorMessage() || 'Verifique a quantidade informada.' }}
                  </span>
                </div>
                <div class="ser-field ser-field--full">
                  <label class="ser-label">Nota de conferência (observações do recebimento)</label>
                  <textarea
                    class="ser-textarea"
                    formControlName="conferenceNote"
                    rows="2"
                    placeholder="Ex.: Volumes conferidos, tudo OK."
                  ></textarea>
                </div>
              </div>
            </div>

            <div class="ser-section ser-section--fiscal" formGroupName="receipt">
              <h3 class="ser-h3">
                <i class="fas fa-file-invoice ser-h3--amber"></i>
                Nota fiscal
              </h3>
              <div class="ser-fields">
                <input type="hidden" formControlName="fiscalDocumentUrl" />
                <div class="ser-field">
                  <label class="ser-label"
                    >Nº do documento <span class="ser-req">*</span></label
                  >
                  <input
                    type="text"
                    class="ser-input ser-input--white"
                    formControlName="documentNumber"
                    [class.ser-input--err]="isReceiptFieldInvalid('documentNumber')"
                    placeholder="Ex.: 12345"
                  />
                </div>
                <div class="ser-field">
                  <label class="ser-label">Série</label>
                  <input
                    type="text"
                    class="ser-input ser-input--white"
                    formControlName="documentSeries"
                    placeholder="Ex.: 1"
                  />
                </div>
                <div class="ser-field ser-field--full">
                  <label class="ser-label"
                    >Chave de acesso da nota <span class="ser-muted">(44 dígitos)</span></label
                  >
                  <input
                    type="text"
                    class="ser-input ser-input--white ser-mono"
                    formControlName="invoiceAccessKey"
                    inputmode="numeric"
                    autocomplete="off"
                    maxlength="54"
                    placeholder="0000 0000 0000 0000 0000 0000 0000 0000 0000 0000 0000"
                    (input)="onNfeAccessKeyInput($event)"
                  />
                </div>
                <div class="ser-field ser-field--full">
                  <div class="ser-label">Anexo da nota fiscal</div>
                  <label class="ser-drop">
                    <input
                      type="file"
                      class="ser-file"
                      accept=".pdf,image/png,image/jpeg,image/jpg"
                      (change)="onDocumentFileChange($event)"
                    />
                    <i class="fas fa-cloud-upload-alt ser-drop__ico"></i>
                    <span class="ser-drop__hint">Toque para anexar o PDF da nota ou uma imagem (PNG, JPG).</span>
                    <span class="ser-drop__sub">PDF, PNG, JPG</span>
                  </label>
                </div>
                <div class="ser-field ser-field--full">
                  <label class="ser-label">Observação da nota</label>
                  <textarea
                    class="ser-textarea ser-textarea--white"
                    formControlName="note"
                    rows="2"
                    placeholder="Ex.: NF de compra de suprimentos"
                  ></textarea>
                </div>
              </div>
            </div>

            <div class="ser-footer">
              <button type="button" class="ser-btn ser-btn--ghost" (click)="onBack()" [disabled]="isSubmitting">
                Cancelar
              </button>
              <button
                type="submit"
                class="ser-btn ser-btn--primary"
                [disabled]="receiptForm.invalid || isSubmitting || showSuccess"
              >
                <i class="fas fa-check" *ngIf="!isSubmitting"></i>
                <i class="fas fa-spinner fa-spin" *ngIf="isSubmitting"></i>
                Concluir
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="ser-loading" *ngIf="isLoading">
    <i class="fas fa-spinner fa-spin"></i>
    <span>Carregando…</span>
  </div>
</app-side-menu>
